import { SET_PRODUCT_ID } from './product-id-actions';
import { MATHLETICS_PRODUCT_ID } from '../../../helpers/backend-constants-contract';

const defaultState = MATHLETICS_PRODUCT_ID;

/**
 * Product ID Reducer
 *
 * Consumes SET_PRODUCT_ID action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {string} - the product id
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case SET_PRODUCT_ID:
        return action.payload;

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/app/product-id/product-id-reducer.js